<template>
    <div class="tiny-mce">
        <!--https://www.tiny.cloud/auth/signup/-->
        <label v-if="block_title" >
            <span v-html="block_title"></span>
            <font-awesome-icon v-if="preview_mode" icon="pencil-alt" v-b-modal="'tiny_'+_uid" />
        </label>
        <div v-if="preview_mode">
            
            <div class="tiny-mce--preview">
                <div v-if="initial_value" v-html="strip_html_from_string(initial_value).slice(0,100) + '...'"></div>
                <small v-else><i>Nessun contenuto inserito</i></small>
            </div>
            
            <b-modal :id="'tiny_'+_uid" :title="'Editor '+block_title" size="xl" hide-footer
                @shown="() => { this.init_editor = true }"
                @hidden="() => { this.init_editor = false }"
            >
                <editor
                    v-if="init_editor"
                    :api-key="tiny_apikey"
                    v-model="tiny_content"
                    @input="() => {
                        this.$emit('input', tiny_content)
                    }"
                    :init="{
                        selector: 'textarea#basic-example',
                        height: height,
                        menubar: false,
                        plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar: 'undo redo | formatselect | ' +
                        'bold italic backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                    }"
                />
            </b-modal>
        </div>
        <div v-if="!preview_mode">
            <editor
                :api-key="tiny_apikey"
                v-model="tiny_content"
                @input="() => {
                    this.$emit('input', tiny_content)
                }"
                :init="{
                    selector: 'textarea#basic-example',
                    height: 200,
                    menubar: false,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | ' +
                    'bold italic backcolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }"
            />
        </div>
    </div>
</template>
<script>

import Editor from '@tinymce/tinymce-vue'
import { strip_html_from_string } from '@/utilities'

export default {
    name: 'tiny-mce',
    components: {
        'editor': Editor,
    },
    props: {
        initial_value: {
            type: String,
            default: '',
        },
        preview_mode: {
            type: Boolean,
            default: false,
        },
        block_title: {
            type: String,
            default: '',
        },
        height: {
            type: Number,
            default: 200,
        }
    },
    data() {
        return {
            tiny_apikey: process.env.VUE_APP_TINYMCE_APIKEY,
            tiny_content: '',
            init_editor: false,
        }
    },
    computed: {
    },
    created()
    {
        this.strip_html_from_string = strip_html_from_string
    },
    mounted() {
        this.tiny_content = this.initial_value
    },
    methods:{
    },
}
</script>

<style lang="scss">
    .tiny-mce
    {
        &--preview
        {
            font-size: 14px;
            margin-bottom: 1rem;
        }
        small
        {
            opacity:0.5;
        }
    }
</style>
